( function () {
    'use strict';
    // Konstruer et object indeholdende alle validations pluginets stadard settings
    // lav 'groups regler' til at håndterer post og by i control-rows
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.form = {};
    e.bootstrap.form.init = function () {
        if ( jQuery( 'form' ).length > 0 ) {
            e.bootstrap.form.validation.setDefaults();
            e.bootstrap.form.build();
            e.bootstrap.form.validation.loadLocalLang();
        }
    };
    e.bootstrap.form.build = function () {
        var jDynamicwebForms = jQuery( '.postform,form[name^="postform"]' ),
            jFieldsetTemplate = jQuery( '<fieldset />' );
        jDynamicwebForms.find( '.formtablecontainer' ).css( {
            visibility: 'hidden'
        } ).end();
        if ( jDynamicwebForms.length === 0 ) {
            return;
        }
        jDynamicwebForms.each( function ( index ) {
            var jOriginalForm = jQuery( this ),
                jTempForm = jQuery( '<form />' ),
                arrNewFormElements = [],
                jNewFieldset = jFieldsetTemplate.clone(),
                inputClass = 'input-block-level',
                usePlaceholder = false;
            jOriginalForm.find( 'input[type="hidden"]' ).appendTo( jTempForm );
            jOriginalForm.find( ':input' ).removeAttr( 'style' );
            jOriginalForm.find( 'td > table td' ).each( function () {
                var jOriginalFormTdEach = jQuery( this );
                //if(jOriginalForm.is('.postform,form[name^="postform"]') === true && jOriginalFormTdEach.find('input[type="text"]').length > 0) {
                if ( jOriginalFormTdEach.find( 'input[type="text"]' ).length > 0 ) {
                    if ( jOriginalFormTdEach.siblings( 'td' ).length > 0 ) {
                        //jOriginalForm.attr('class', 'form-horizontal');
                        usePlaceholder = ( 'placeholder' in document.createElement( 'input' ) );
                    }
                    else {
                        //jOriginalForm.attr('class', 'form-vertical');
                    }
                    jOriginalForm.attr( 'class', 'form-vertical' );
                }
                if ( jOriginalFormTdEach.find( 'table' ).is( 'table table table' ) ) {
                    arrNewFormElements.push( {
                        type: 'separator'
                    } );
                }
                else if ( jOriginalFormTdEach.find( ':input' ).length > 0 ) {
                    arrNewFormElements.push( {
                        type: ( function () {
                            if ( jOriginalFormTdEach.find( 'input[type="checkbox"]' ).length > 0 ) {
                                return 'input-checkbox';
                            }
                            if ( jOriginalFormTdEach.find( 'input[type="radio"]' ).length > 0 ) {
                                return 'input-radio';
                            }
                            if ( jOriginalFormTdEach.find( 'textarea' ).length > 0 ) {
                                return 'input-textarea';
                            }
                            if ( jOriginalFormTdEach.find( 'select' ).length > 0 ) {
                                return 'input-select';
                            }
                            if ( jOriginalFormTdEach.find( 'input[type="button"],input[type="reset"]' ).length > 0 ) {
                                return 'input-button';
                            }
                            else {
                                return 'input';
                            }
                        }() ),
                        content: jOriginalFormTdEach.html(),
                        required: jOriginalFormTdEach.find( 'img:last-child' ).length
                    } );
                }
                else if ( jOriginalFormTdEach.is( 'td[colspan="2"]' ) ) {
                    arrNewFormElements.push( {
                        type: 'legend',
                        content: jOriginalFormTdEach.html()
                    } );
                }
                else if ( jOriginalFormTdEach.text() !== '' ) {
                    arrNewFormElements.push( {
                        type: 'label',
                        content: jOriginalFormTdEach.text(),
                        required: jOriginalFormTdEach.find( 'img:last-child' ).length
                    } );
                }
            } );
            for ( var i = 0; i < arrNewFormElements.length; i++ ) {
                //console.log(arrNewFormElements[i].type)
                var jControlGroup = jQuery( '<div class="control-group">' + '</div>' ),
                    jInput;
                if ( arrNewFormElements[ i ].type === 'legend' ) {
                    jNewFieldset.append( '<p>' + arrNewFormElements[ i ].content + '</p>' );
                }
                else if ( arrNewFormElements[ i ].type === 'input-radio' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        jControlGroup.append( '<label class="control-label">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                    }
                    jControlGroup.append( '<div class="controls">' + '</div>' );
                    jControlGroup = jControlGroup.find( '.controls' );
                    var jFormControlRadio = jQuery( arrNewFormElements[ i ].content ),
                        radioGroupName = jFormControlRadio.filter( 'input' ).attr( 'name' );
                    while ( i < arrNewFormElements.length && ( arrNewFormElements[ i ].type === 'input-radio' && jQuery( arrNewFormElements[ i ].content ).filter( 'input' ).attr( 'name' ) === radioGroupName ) || ( arrNewFormElements[ i ].type === 'label' && jQuery.trim( arrNewFormElements[ i ].content ) === '' ) ) {
                        jFormControlRadio = jQuery( arrNewFormElements[ i ].content );
                        jControlGroup.append( jFormControlRadio.filter( 'label' ).addClass( 'radio' ).prepend( jFormControlRadio.filter( 'input' ).removeClass() ) );
                        i++;
                    }
                    i--;
                    jControlGroup = jControlGroup.parent();
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-select' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        if ( jQuery( arrNewFormElements[ i ].content ).filter( 'input[name*="Mail"],input[name*="mail"]' ).length > 0 ) {
                            jControlGroup.addClass( 'email' );
                        }
                        jControlGroup.append( '<label class="control-label" for="input_' + index + '_' + i + '">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                    }
                    jControlGroup.append( '<div class="controls">' + arrNewFormElements[ i ].content + '</div>' ).find( '.controls:last > :input' ).attr( 'id', 'input_' + index + '_' + i ).addClass( inputClass );
                    var aSelect = jControlGroup.find( 'select' );
                    if ( aSelect.length === 1 ) {
                        aSelect.find( 'option[value="invalid"]' ).attr( 'value', '' );
                        if ( aSelect.is( '[name="ReplaceRecipient"]' ) === true ) {
                            aSelect.on( 'change', function () {
                                var jThis = jQuery( this );
                                if ( e.util.validateEmail( jThis.val() ) || e.util.validateEmail( jThis.val().split( ',' )[ 0 ] ) ) {
                                    jQuery( this.form ).find( 'input[name="Recipient"]' ).val( jThis.val() );
                                }
                                else {
                                    jQuery( this.form ).find( 'input[name="Recipient"]' ).val( jThis.data( 'Original-Recipient' ) );
                                }
                            } ).data( {
                                'Original-Recipient': jQuery( 'input[name="Recipient"]' ).val()
                            } );
                        }
                    }
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-checkbox' ) {
                    jControlGroup.append( '<div class="controls">' + '</div>' );
                    while ( i < arrNewFormElements.length && arrNewFormElements[ i ].type === 'input-checkbox' ) {
                        var jFormControlCheckbox = jQuery( arrNewFormElements[ i ].content );
                        jControlGroup.find( '.controls' ).append( jFormControlCheckbox.filter( 'label' ).addClass( 'checkbox' ).prepend( jFormControlCheckbox.filter( 'input' ).removeClass().addClass( function () {
                            return ( this.name.indexOf( 'required' ) > -1 ? 'required' : '' );
                        } ) ) );
                        i++;
                    }
                    i--;
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-textarea' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        if ( usePlaceholder === false ) {
                            jControlGroup.append( '<label class="control-label" for="input_' + index + '_' + i + '">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                        }
                    }
                    jInput = jControlGroup.append( '<div class="controls">' + arrNewFormElements[ i ].content + '</div>' ).find( '.controls:last > :input' ).attr( 'id', 'input_' + index + '_' + i ).addClass( inputClass );
                    if ( usePlaceholder === true ) {
                        jInput.attr( 'placeholder', arrNewFormElements[ i - 1 ].content );
                    }
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input' ) {
                    if ( arrNewFormElements[ i - 1 ].type === 'label' ) {
                        if ( arrNewFormElements[ i - 1 ].required ) {
                            jControlGroup.addClass( 'required' );
                        }
                        if ( jQuery( arrNewFormElements[ i ].content ).filter( 'input[name*="Mail"],input[name*="mail"]' ).length > 0 ) {
                            jControlGroup.addClass( 'email' );
                        }
                        if ( usePlaceholder === false ) {
                            jControlGroup.append( '<label class="control-label" for="input_' + index + '_' + i + '">' + arrNewFormElements[ i - 1 ].content + '</label>' );
                        }
                    }
                    jInput = jControlGroup.append( '<div class="controls">' + arrNewFormElements[ i ].content + '</div>' ).find( '.controls:last > :input' ).attr( 'id', 'input_' + index + '_' + i ).addClass( inputClass );
                    if ( usePlaceholder === true ) {
                        jInput.attr( 'placeholder', arrNewFormElements[ i - 1 ].content );
                    }
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'input-button' ) {
                    jControlGroup = jQuery( '<div class="form-actions">' + '</div>' );
                    jQuery( arrNewFormElements[ i ].content ).filter( 'input' ).addClass( 'btn' ).removeAttr( 'onclick' ).first().addClass( 'btn-primary' ).end().each( function () {
                        var jThis = jQuery( this );
                        jControlGroup.append( function () {
                            if ( jThis.is( '.btn-primary' ) ) {
                                return jQuery( '<input>' ).attr( {
                                    'type': 'submit',
                                    'name': jThis.val(),
                                    'value': jThis.val(),
                                    'class': jThis.attr( 'class' ) + ( arrNewFormElements.length > 3 ? ' btn-large' : '' )
                                } ).after( ' ' );
                            }
                            else {
                                return jThis.addClass( 'btn-link' );
                            }
                        } );
                    } );
                    jControlGroup.appendTo( jNewFieldset );
                }
                else if ( arrNewFormElements[ i ].type === 'separator' ) {
                    jNewFieldset.append( '<hr>' );
                }
            }
            jTempForm.children().appendTo( jOriginalForm.empty().append( jNewFieldset ) );
            jOriginalForm.find( '.required :input' ).addClass( 'required' );
            jOriginalForm.find( '.email :input' ).addClass( 'email' );
            jOriginalForm.removeAttr( 'onsubmit' ).removeAttr( 'style' ).validate( {
                submitHandler: function ( form ) {
                    form.action = '/Admin/Public/FormMail.aspx?mode=20';
                    form.submit();
                }
            } );
            //jOriginalForm.closest('[class^="span"]').wrapInner('<div class="well" />');
        } );
    };
    e.bootstrap.form.validation = {};
    e.bootstrap.form.validation.init = function () {};
    e.bootstrap.form.validation.setDefaults = function () {
        jQuery.validator.setDefaults( {
            errorElement: 'small',
            errorPlacement: function ( error, element ) {
                if ( element.parent().is( 'label.radio' ) ) {
                    error.addClass( 'help-block' ).appendTo( element.closest( '.controls' ) );
                }
                if ( element.parent().is( 'label.checkbox' ) ) {
                    error.addClass( 'help-block' ).appendTo( element.parent() );
                }
                else if ( element.next().is( '.help-block' ) ) {
                    error.addClass( 'help-inline' ).insertAfter( element );
                }
                else {
                    if ( element.closest( 'form' ).is( '.form-vertical' ) ) {
                        error.addClass( 'help-block' ).appendTo( element.closest( '.controls' ) );
                    }
                    else {
                        error.addClass( 'help-inline' ).appendTo( element.closest( '.controls' ) );
                    }
                }
            },
            highlight: function ( element, errorClass, validClass ) {
                var jElement = jQuery( element );
                if ( jElement.parent().is( 'label.checkbox' ) ) {
                    jElement.parent().addBack().addClass( errorClass ).removeClass( validClass );
                }
                else {
                    jElement.closest( '.control-group' ).addBack().addClass( errorClass ).removeClass( validClass );
                }
            },
            unhighlight: function ( element, errorClass, validClass ) {
                var jElement = jQuery( element ),
                    jControlGroup = jElement.closest( '.control-group' );
                jElement.addClass( validClass ).removeClass( errorClass );
                if ( jControlGroup.find( errorClass ).length === 0 ) {
                    jControlGroup.addClass( validClass ).removeClass( errorClass );
                }
                if ( jElement.parent().is( 'label.checkbox' ) ) {
                    jElement.parent().addBack().addClass( validClass ).removeClass( errorClass );
                }
            },
            submitHandler: function ( form ) {
                form.submit();
            }
        } );
    };
    e.bootstrap.form.validation.loadLocalLang = function () {
        if ( e.config.pageLanguage === 'da' ) {
            /*
             * Translated default messages for the jQuery validation plugin.
             * Locale: DA
             */
            jQuery.extend( jQuery.validator.messages, {
                required: 'Dette felt er påkrævet.',
                maxlength: jQuery.validator.format( 'Indtast højst {0} tegn.' ),
                minlength: jQuery.validator.format( 'Indtast mindst {0} tegn.' ),
                rangelength: jQuery.validator.format( 'Indtast mindst {0} og højst {1} tegn.' ),
                email: 'Indtast en gyldig email-adresse.',
                url: 'Indtast en gyldig URL.',
                date: 'Indtast en gyldig dato.',
                number: 'Indtast et tal.',
                digits: 'Indtast kun hele tal.',
                equalTo: 'Indtast den samme værdi igen.',
                range: jQuery.validator.format( 'Angiv en værdi mellem {0} og {1}.' ),
                max: jQuery.validator.format( 'Angiv en værdi der højst er {0}.' ),
                min: jQuery.validator.format( 'Angiv en værdi der mindst er {0}.' ),
                creditcard: 'Indtast et gyldigt kreditkortnummer.'
            } );
        }
        else if ( e.config.pageLanguage !== 'en' ) {
            if ( e.config.pageLanguage === 'nb' || e.config.pageLanguage === 'nn' ) {
                e.config.pageLanguage = 'no';
            }
            jQuery.ajax( {
                url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.11.0/localization/messages_' + e.config.pageLanguage + '.js',
                dataType: 'script',
                cache: true
            } );
        }
    };
}() );
